"use strict";

exports.__esModule = true;
exports.EditableGridCellWrapper = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _reResizable = require("re-resizable");
var _reactDnd = require("react-dnd");
var _reactIntl = require("react-intl");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _ElementEditorContextMenu = require("../../ConfigurableLayout/ElementEditor/ElementEditorContextMenu");
var _Core = require("../../Core");
var _gridUtils = require("./gridUtils");
var _dec, _dec2, _class, _EditableGridCellWrapper;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var elementSource = {
  beginDrag: function beginDrag(props) {
    var element = props.element,
      path = props.path,
      elementEditor = props.elementEditor;
    elementEditor.beginDrag(path);
    return {
      element: element,
      path: path
    };
  },
  endDrag: function endDrag(props) {
    var elementEditor = props.elementEditor;
    elementEditor.endDrag();
  }
};
var getPosition = function getPosition(_ref) {
  var x = _ref.x,
    y = _ref.y,
    width = _ref.width,
    height = _ref.height;
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
};

/**
 * Displays an editable grid.
 */
var EditableGridCellWrapper = exports.EditableGridCellWrapper = (_dec = _ConfigurableLayout.ElementEditorContext.withContext, _dec2 = (0, _reactDnd.DragSource)("element", elementSource, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}), (0, _reactIntl.injectIntl)(_class = _dec(_class = _dec2(_class = (_EditableGridCellWrapper = /*#__PURE__*/function (_PureComponent) {
  function EditableGridCellWrapper() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
    _this.state = {
      error: undefined,
      isResizing: false,
      original: getPosition(_this.props.element.props),
      current: getPosition(_this.props.element.props)
    };
    _this.handleClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var _this$props = _this.props,
        path = _this$props.path,
        elementEditor = _this$props.elementEditor;
      elementEditor.selectElementAt(path);
    };
    _this.handleResizeStart = function (e) {
      e.stopPropagation();
      e.preventDefault();
      var _this$props2 = _this.props,
        path = _this$props2.path,
        elementEditor = _this$props2.elementEditor,
        element = _this$props2.element;
      if (!elementEditor.isElementSelectedAt(path)) {
        elementEditor.selectElementAt(path);
      }
      var position = getPosition(element.props);
      _this.setState({
        isResizing: true,
        original: position,
        current: position
      });
    };
    _this.handleResize = function (e, direction, ref, delta) {
      var _this$state$original = _this.state.original,
        width = _this$state$original.width,
        height = _this$state$original.height;
      var _this$state$original2 = _this.state.original,
        x = _this$state$original2.x,
        y = _this$state$original2.y;
      if (direction === "top" || direction === "topRight" || direction === "topLeft") {
        y -= delta.height;
      }
      if (direction === "left" || direction === "topLeft" || direction === "bottomLeft") {
        x -= delta.width;
      }
      var next = {
        x: Math.max(0, x),
        y: Math.max(0, y),
        width: width + delta.width,
        height: height + delta.height
      };
      _this.setState({
        current: next
      });
    };
    _this.handleResizeStop = function () {
      var _this$props3 = _this.props,
        elementEditor = _this$props3.elementEditor,
        path = _this$props3.path,
        grid = _this$props3.grid;
      var current = _this.state.current;
      elementEditor.setProps(path, (0, _gridUtils.getGridCellPosition)(grid, current));
      _this.setState({
        isResizing: false
      });
    };
    _this.handleContextMenu = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var _this$props4 = _this.props,
        path = _this$props4.path,
        elementEditor = _this$props4.elementEditor,
        intl = _this$props4.intl;
      var menu = /*#__PURE__*/_react["default"].createElement(_ElementEditorContextMenu.ElementEditorContextMenu, {
        path: path,
        elementEditor: elementEditor,
        intl: intl
      });
      (0, _core.showContextMenu)({
        content: menu,
        targetOffset: {
          left: e.clientX,
          top: e.clientY
        }
      });
    };
    return _this;
  }
  _inheritsLoose(EditableGridCellWrapper, _PureComponent);
  EditableGridCellWrapper.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    var position = getPosition(props.element.props);
    if (prevState.original.x === position.x && prevState.original.y === position.y && prevState.original.width === position.width && prevState.original.height === position.height) {
      return null;
    }
    return {
      original: position,
      current: position
    };
  };
  var _proto = EditableGridCellWrapper.prototype;
  _proto.componentDidCatch = function componentDidCatch(error) {
    this.setState({
      error: error
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props5 = this.props,
      isDragging = _this$props5.isDragging,
      grid = _this$props5.grid,
      connectDragSource = _this$props5.connectDragSource,
      element = _this$props5.element,
      render = _this$props5.render,
      index = _this$props5.index,
      elementEditor = _this$props5.elementEditor,
      path = _this$props5.path;
    var error = this.state.error;
    if (error != null) {
      return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
        error: error,
        onReload: function onReload() {
          return _this2.setState({
            error: undefined
          });
        }
      });
    }
    if (isDragging) {
      return null;
    }
    var _this$state = this.state,
      isResizing = _this$state.isResizing,
      _this$state$current = _this$state.current,
      x = _this$state$current.x,
      y = _this$state$current.y,
      width = _this$state$current.width,
      height = _this$state$current.height;
    var isSelected = elementEditor.isElementSelectedAt(path);
    var rowHeight = (0, _gridUtils.getGridRowHeight)(grid);
    var columnWidth = (0, _gridUtils.getGridColumnWidth)(grid);
    var style = {
      position: "absolute",
      left: x,
      top: y,
      width: width,
      height: height,
      zIndex: isSelected ? 10 : undefined,
      background: isResizing ? "rgba(175, 226, 241, 0.3)" : undefined,
      outline: "dashed " + (isSelected ? "#26bbe4" : "rgba(0, 0, 0, 0.1)") + " 1px"
    };
    return /*#__PURE__*/_react["default"].createElement(_reResizable.Resizable, {
      size: {
        width: width,
        height: height
      },
      style: style,
      minWidth: columnWidth,
      minHeight: rowHeight,
      grid: [columnWidth, rowHeight],
      onResizeStart: this.handleResizeStart,
      onResize: this.handleResize,
      onResizeStop: this.handleResizeStop
    }, isResizing ? null : connectDragSource(/*#__PURE__*/_react["default"].createElement("div", {
      onContextMenu: this.handleContextMenu
    }, _react.Children.map(render(element, index), function (child) {
      return /*#__PURE__*/(0, _react.cloneElement)(child, {
        onClick: _this2.handleClick,
        onClickCapture: element.children.length === 0 ? _this2.handleClick : undefined
      });
    }))));
  };
  return EditableGridCellWrapper;
}(_react.PureComponent), _EditableGridCellWrapper.defaultProps = {
  intl: undefined,
  elementEditor: undefined,
  connectDragSource: undefined,
  isDragging: undefined,
  width: 128,
  height: 64,
  x: 0,
  y: 0
}, _EditableGridCellWrapper)) || _class) || _class) || _class);